





































































import Vue from "vue";
import storeHelper from "../../../store/store-helper";
import Shared from "../../../shared";
import { NewsArticlePost, NewsArticlePatch, NewsArticle, Portal } from "@infoland/iprova-api";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";

import QuillEditor from "../../generic/QuillEditor.vue";
import _ from "lodash";
import * as Enums from "../../../enums";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "CreateEditCard",
    components: { QuillEditor },
    props: {
        id: Number,
        currentPortalId: Number,
        cancelFunction: { type: Function }
    },
    data: function () {
        return {
            isNew: !this.id || !(this.id > 0),
            newsArticle: { content: "" } as NewsArticle,
            valid: true,
            submitted: false,
            closeDialog: this.$props.closeDialogFunction,
            cancel: this.$props.cancelFunction,
            articleLoaded: false,
            portals: [] as Portal[],
            portalGroupTree: [],
            selectedPortals: [],
            distributionMode: Enums.NewsDistributionToPortals.ThisPortal,
            selectionType: "leaf",
            portalEnumValue: Enums.NewsDistributionToPortals.ThisPortal,
            portalsWhereIAmManagerEnumValue: Enums.NewsDistributionToPortals.PortalsWhereIAmManager,
            allPortalsEnumValue: Enums.NewsDistributionToPortals.AllPortals,
            treeViewOpenNodes: [],
            radioButtonColor: "primary",
            newsArticleLoaded: false
        };
    },
    computed: {
        containsMultiplePortals(): boolean {
            return this.portals?.length > 1;
        },
        portal(): Portal {
            return storeHelper.portalStore.portals.find(p => p.portal_id === this.currentPortalId);
        },
        currentPortalName(): string {
            return this.portal.name;
        }
    },
    async created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.saveNewsArticle, cancel: this.onCancel });
        this.portals = storeHelper.portalStore.portals.filter(p => p.can_manage_news);
        this.portalGroupTree = this.getPortalGroupsTree();

        if (!this.isNew) {
            await storeHelper.newsArticleStore.loadNewsArticleAsync(this.$props.id, true);
            this.newsArticle = storeHelper.newsArticleStore.getNewsArticle;
            this.articleLoaded = true;
            this.selectedPortals = this.getSelectedPortals();
            this.distributionMode = this.getDistributionMode();
        }
        this.newsArticleLoaded = true;
    },
    beforeDestroy() {
        this.clearHandlers();
    },
    methods: {
        validateForm() {
            const formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
            const treeViewIsValid = this.treeValidator();
            if (!formIsValid) this.focusOnFirstInvalidElement();
            else if (!treeViewIsValid) this.focusOnInvalidTreeView();
            return formIsValid && treeViewIsValid;
        },
        focusOnFirstInvalidElement() {
            const formComponent = this.$refs.form as Vue;
            const firstInvalidElement = _.find(formComponent.$children, ["valid", false]);
            firstInvalidElement.focus();
        },
        focusOnInvalidTreeView() {
            ((this.$refs.portalTreeviewRef as Vue).$refs.input as HTMLFormElement).focus();
        },
        async saveNewsArticle() {
            if (this.validateForm()) {
                this.submitted = true;
                this.valid = false;
                const article = {
                    title: this.newsArticle.title,
                    summary: this.newsArticle.summary,
                    content: this.newsArticle.content,
                    portal_ids: this.getSavedSelectedPortals()
                };

                if (this.isNew) {
                    const result = await storeHelper.newsArticleStore.createNewsArticleAsync(article as NewsArticlePost);

                    if (result) {
                        storeHelper.siteStore.setSnackBarMessage(
                            this.$t("general.messages.successfullyCreated", {
                                var1: this.$t("newsArticle.snackbarName")
                            }).toString(),
                            false,
                            Enums.SnackBarTimeout.short
                        );
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    const result = await storeHelper.newsArticleStore.saveNewsArticleAsync(this.$props.id, article as NewsArticlePatch);
                    if (result) {
                        storeHelper.siteStore.setSnackBarMessage(
                            this.$t("general.messages.successfullySaved", {
                                var1: this.$t("newsArticle.snackbarName")
                            }).toString(),
                            false,
                            Enums.SnackBarTimeout.short
                        );
                        return true;
                    } else {
                        return false;
                    }
                }
            }
            return false;
        },
        required() {
            return v => !!v || `${this.$t("validation.isRequired")}`;
        },
        getContentfromQuill(event) {
            this.newsArticle.content = event;
        },
        getPortalGroupsTree(): Array<any> {
            const portalGroupsResult = _(this.portals)
                .groupBy("portal_group.order")
                .orderBy("key")
                .map(portalGroupGrouping => {
                    const firstPortalInGroup = _.first(portalGroupGrouping).portal_group;
                    const id = firstPortalInGroup.portal_group_id;
                    const name = firstPortalInGroup.name;

                    const children = _.map(portalGroupGrouping, portal => {
                        return {
                            id: portal.portal_id,
                            name: portal.name
                        };
                    });

                    return {
                        id,
                        name,
                        children
                    };
                })
                .valueOf();

            if (portalGroupsResult.length == 1) this.treeViewOpenNodes = [portalGroupsResult[0].id];

            return portalGroupsResult;
        },
        getDistributionMode() {
            if (this.selectedPortals.length == 1 && this.selectedPortals[0] == this.currentPortalId)
                return Enums.NewsDistributionToPortals.ThisPortal;
            //current portal
            else if (this.selectedPortals.length == this.portals.length) {
                return Enums.NewsDistributionToPortals.PortalsWhereIAmManager;
            } else return Enums.NewsDistributionToPortals.AllPortals; //multiple portal or not current one -> distribution mode -> select from all portals
        },
        getSelectedPortals() {
            const options = this.newsArticle.portals.map(item => item.portal_id);

            this.treeViewOpenNodes = _.uniq(
                _.map(this.portals, function (portal) {
                    if (_.includes(options, portal.portal_id)) return portal.portal_group.portal_group_id;
                })
            );

            return options;
        },
        getSavedSelectedPortals() {
            if (this.distributionMode == Enums.NewsDistributionToPortals.ThisPortal) return [this.currentPortalId];
            else if (this.distributionMode == Enums.NewsDistributionToPortals.AllPortals) return this.selectedPortals;
            else return _.map(this.portals, portal => portal.portal_id);
        },
        treeValidator(): boolean {
            if (this.distributionMode == Enums.NewsDistributionToPortals.AllPortals && this.selectedPortals.length == 0) {
                this.radioButtonColor = "red";
                return false;
            } else {
                this.radioButtonColor = "primary";
                return true;
            }
        },
        async onCancel(): Promise<boolean> {
            if (!this.isNew) {
                this.cancelFunction();
                return false;
            }
            return true;
        }
    }
});
